

import React, { useState, useEffect } from "react"
import { ReactComponent as BtnRound } from "../../svg/btnRRound.svg";
import { ReactComponent as PaginationRoundBtn } from "../../svg/pginationRound.svg";
import team from "../../store/team";
import { observer } from "mobx-react-lite";

const TeamMembers = observer((props) => {
    //console.log(props);
    const [selectedMemberData, setSelectedMemberData] = useState(null);

    const setSelectedMember = (member) => {
        console.log(member)
        setSelectedMemberData(member);
    }

    /* useEffect(() => {
        if (imageFull !== null) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "scroll";

        }
    }, [imageFull]); */

    const dateTimeFormat = new Intl.DateTimeFormat('ru', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    return (
        <div className={props.className + ' team-viewer panel'} >
            <div className="selected-member">

            {  
               (typeof team.currentMember !== 'undefined' && team.currentMember !=null)
               ?(<>
                   <div className="member">
                     {
                        (team.currentMember.media.length>0)
                        ?<img class="photo"  data={team.currentMember .id} src={team.currentMember .media[0].low} alt="" />
                        :<></>
                    }

                                <div className="info">
                                   <div className="name">{team.currentMember .name}</div>
                                   <div className="title">{team.currentMember .title}</div>
                                </div>
                          </div>
                         
                         
                         <div className="details">
                            <div className="navi tabs">
                                <div className="tab" onClick={() =>  setSelectedMember(team.currentMember.achievs)}  >Достижения</div>
                                <div className="tab" onClick={() =>  setSelectedMember(team.currentMember.educat)} >Образование</div>
                                <div className="tab" onClick={() =>  setSelectedMember(team.currentMember.expere)}>Опыт</div>
                            </div>
                            <div className="data">
                                
                                {
                                    (typeof selectedMemberData!== 'undefined' && selectedMemberData !==null && selectedMemberData.length >0)
                                    ? selectedMemberData.map((data) => {
                                        return (<p class="marker">{data}</p>)
                                    })
                                    :<></>
                                }
                                
                            </div>
                         </div>
                        </>)
                        :(<div class="centered full-wh">Выберите сотрудника</div> )
                    }
                 
            
        </div>


            <div className="members" >
                <div className="list">
                    {   
                       team.currentPages.map((member) => {
                        
                            return (
                                <div className="member small" key={member.id} onClick={() => {team.setCurrentMemberData(member);  setSelectedMember(member.achievs);}} >
                                    {
                                        (member.media.length>0)?  <img class="photo" src={member.media[0].low}></img>  :<></>
                                    }  
                                    <div className="info">
                                        <div className="name"> <nobr>{member.name}</nobr></div>
                                        <div className="title">{member.title}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>

                
              
                <div className="navi doted centered">
                {((len,pageId) => {
                    let td = [];
                    for (let i = 1; i <= len; i++) {
                    td.push(<div class={((pageId==i)?'active':'')+" dot"} onClick={() => {team.goPage(i);}} key={i}> </div>);
                    }
                    return td;
                })(team.pagesCount,team.currentPageId)}
          
          
          
          
         
                    
                </div>
            </div>
        </div>
    );
})

export default TeamMembers;
